import { useState, useContext } from 'react'
import WODetailsModal from '../sub-modals/WODetailsSubModal'
import styles from './styles.module.css'
import { WoDetailContext } from '../../../context/context'

export default function AdditionalActions() {
  const { data } = useContext(WoDetailContext)

  const [modalOpen, setModalOpen] = useState<boolean>(false)
  const [modalName, setModalName] = useState<string>('')

  const handleOpen = (e: any) => {
    setModalName(e.target.innerText)
    setModalOpen(true)
  }
  const handleClosed = () => {
    setModalOpen(false)
    setModalName('')
  }

  const jobIsDone = ['cancelled', 'cancelled_onsite', 'completed'].includes(data.status || '')

  return (
    <div>
      <div className={styles.heading}>Additional Actions</div>
      <WODetailsModal
        isOpen={modalOpen}
        handleClosed={handleClosed}
        actionName={modalName}
      />
      <div className={styles.container}>
        <button
          className={styles.additionalActions}
          onClick={(e) => handleOpen(e)}
          disabled={jobIsDone}>
          Complete Work Order
        </button>
        <button
          className={styles.additionalActions}
          disabled={jobIsDone}
          onClick={(e) => handleOpen(e)}>
          Cancel Order
        </button>
        <button
          className={styles.additionalActions}
          onClick={(e) => handleOpen(e)}>
          Clone Order
        </button>
        <button
          className={styles.additionalActions}
          onClick={(e) => handleOpen(e)}>
          Installation Images
        </button>
      </div>
    </div>
  )
}
